import { type DocumentNode, gql } from '@apollo/client';

const updateFieldDefMutation: DocumentNode = gql`
  mutation updateFieldDefMutation(
    $fieldDefId: ID!
    $name: String
    $choices: [String]
    $dataType: String
    $fieldType: String
    $highlightIfBlank: Boolean
    $isEditable: Boolean
    $isMultivalued: Boolean
    $isRequired: Boolean
    $isSystemField: Boolean
    $scope: [String!]!
    $dateDisplayStyle: String
  ) {
    updateFieldDef(
      fieldDefId: $fieldDefId
      name: $name
      choices: $choices
      dataType: $dataType
      fieldType: $fieldType
      highlightIfBlank: $highlightIfBlank
      isEditable: $isEditable
      isMultivalued: $isMultivalued
      isRequired: $isRequired
      isSystemField: $isSystemField
      scope: $scope
      dateDisplayStyle: $dateDisplayStyle
    ) {
      fieldDef {
        id
        name
        slug
        fieldType
        dataType
        isSystemField
        isRequired
        isEditable
        isMultivalued
        choices
        dateDisplayStyle
        scope
      }
    }
  }
`;

export default updateFieldDefMutation;
